import * as THREE from 'three'
// import { EffectComposer } from 'three/addons/postprocessing/EffectComposer.js'
// import { RenderPass } from 'three/addons/postprocessing/RenderPass.js'
// import { ShaderPass } from 'three/addons/postprocessing/ShaderPass.js'
import gsap from 'gsap'

import vertex from '../shaders/vertex-bizarre.glsl'
import fragment from '../shaders/fragment-bizarre.glsl'
// import postVertex from '../shaders/post-vertex-bizarre.glsl'
// import postFragment from '../shaders/post-fragment-bizarre.glsl'

export default class webglBizarre {
  constructor(dom, img) {
    this.gunya = 0.0

    this.windowWidth = window.innerWidth
    this.breakPoint = 760
    this.container = dom
    this.img = img.currentSrc
    this.width = this.container.offsetWidth
    this.height = this.container.offsetHeight

    this.scene = new THREE.Scene()

    this.renderer = new THREE.WebGLRenderer({
      antialias: true,
      alpha: true,
    })
    this.renderer.setPixelRatio(window.devicePixelRatio)
    this.renderer.setSize(this.width, this.height)
    // this.renderer.setClearColor(0xcccccc, 1.0)
    // this.renderer.setClearAlpha(1.0)
    // this.renderer.autoClear = false
    this.renderer.sortObjects = false
    this.renderer.outputColorSpace = THREE.SRGBColorSpace

    this.container.appendChild(this.renderer.domElement)

    const frustumSize = 1
    this.camera = new THREE.OrthographicCamera(
      frustumSize / -2,
      frustumSize / 2,
      frustumSize / 2,
      frustumSize / -2,
      -1000,
      1000
    )
    this.camera.position.set(0, 0, 2)

    this.time = 0
    this.speed = 0
    this.targetSpeed = 0
    this.mouse = new THREE.Vector2()
    this.followMouse = new THREE.Vector2()
    this.prevMouse = new THREE.Vector2()

    this.createMesh()
    // this.composerPass()
    this.render()
    this.addEvents()
    this.onResize()

    if (this.windowWidth >= this.breakPoint) {
      // pc
      this.scrollY
      window.addEventListener('scroll', () => {
        this.scrollY = window.scrollY
      })
    }
  }

  createMesh() {
    const texture = new THREE.TextureLoader().load(this.img)
    texture.magFilter = THREE.LinearFilter
    texture.minFilter = THREE.LinearFilter
    texture.wrapS = THREE.RepeatWrapping
    texture.wrapT = THREE.RepeatWrapping
    texture.needsUpdate = true

    const imgAspect = this.height / this.width
    let a1
    let a2
    if (this.height / this.width > imgAspect) {
      a1 = (this.width / this.height) * imgAspect
      a2 = 1
    } else {
      a1 = 1
      a2 = this.height / this.width / imgAspect
    }


    if (this.windowWidth <= this.breakPoint) {
      // mobile
      this.gunya = 0.07
    } else {
      // pc
      this.gunya = 0.005
    }

    const geometry = new THREE.PlaneGeometry(1, 1, 80, 80)
    const material = new THREE.ShaderMaterial({
      extensions: {
        derivatives: '#extension GL_OES_standard_derivatives : enable',
      },
      side: THREE.DoubleSide,
      transparent: true,
      uniforms: {
        uTime: {
          type: 'f',
          value: 0.0,
        },
        uResolution: {
          type: 'v4',
          value: new THREE.Vector4(this.width, this.height, a1, a2),
        },
        uTexture: {
          type: 't',
          value: texture,
        },
        uPercent: {
          value: 0.0,
        },
        uGunya: {
          value: this.gunya
        }
      },
      vertexShader: vertex,
      fragmentShader: fragment,
    })
    const mesh = new THREE.Mesh(geometry, material)
    this.scene.add(mesh)
  }

  // composerPass() {
  //   this.composer = new EffectComposer(this.renderer)
  //   this.renderPass = new RenderPass(this.scene, this.camera)
  //   this.renderPass.clearColor = new THREE.Color(255, 0, 0)
  //   this.renderPass.clearAlpha = 1.0
  //   this.renderPass.clear = false
  //
  //   const effect = {
  //     side: THREE.DoubleSide,
  //     transparent: true,
  //     uniforms: {
  //       tDiffuse: {
  //         value: null,
  //       },
  //       uResolution: {
  //         value: new THREE.Vector2(1.0, this.height / this.width),
  //       },
  //       uMouse: {
  //         value: new THREE.Vector2(-10, -10),
  //       },
  //       uVelo: {
  //         value: 0,
  //       },
  //     },
  //     vertexShader: postVertex,
  //     fragmentShader: postFragment,
  //   }
  //   this.customPass = new ShaderPass(effect)
  //   this.customPass.renderToScreen = true
  //   this.customPass.material.transparent = true
  //
  //   this.composer.addPass(this.renderPass)
  //   this.composer.addPass(this.customPass)
  // }

  getSpeed() {
    this.speed = Math.sqrt(
      Math.pow(this.prevMouse.x - this.mouse.x, 2) + Math.pow(this.prevMouse.y - this.mouse.y, 2)
    )
    this.targetSpeed -= 0.1 * (this.targetSpeed - this.speed)
    this.followMouse.x -= 0.1 * (this.followMouse.x - this.mouse.x)
    this.followMouse.y -= 0.1 * (this.followMouse.y - this.mouse.y)
    this.prevMouse.x = this.mouse.x
    this.prevMouse.y = this.mouse.y
  }

  render() {
    this.getSpeed()
    this.time += 0.05
    this.scene.children[0].material.uniforms.uTime.value = this.time
    // this.customPass.uniforms.uMouse.value = this.followMouse
    // this.customPass.uniforms.uVelo.value = Math.min(this.targetSpeed, 0.05)
    this.targetSpeed *= 0.999
    // if (this.composer) this.composer.render()

    if (this.windowWidth >= this.breakPoint) {
      // pc
      if (this.scrollY >= 650) {
        gsap.to(this.scene.children[0].material.uniforms.uGunya, {
          duration: 5,
          value: 0.04,
          ease: "expo.out"
        })
      }
      if (this.scrollY >= 2500) {
        gsap.to(this.scene.children[0].material.uniforms.uGunya, {
          duration: 10,
          value: 0.5,
          ease: "expo.out"
        })
      }
      if (this.scrollY > 650){
        gsap.to(this.scene.children[0].material.uniforms.uGunya, {
          duration: 5,
          value: 0.003,
          ease: "expo.out"
        })
      }
    }

    // this.scene.children[0].material.uniforms.uGunya.value = this.gunya

    this.renderer.render(this.scene, this.camera)
    requestAnimationFrame(this.render.bind(this))
  }

  addEvents() {
    this.container.addEventListener('mousemove', this.onMousemove.bind(this))
    window.addEventListener('resize', this.onResize.bind(this))
  }

  onMousemove(e) {
    this.mouse.x = e.offsetX / this.width
    this.mouse.y = 1.0 - e.offsetY / this.height
  }

  onResize() {
    const w = this.container.offsetWidth
    const h = this.container.offsetHeight
    this.renderer.setSize(w, h)
    this.camera.aspect = w / h
    this.camera.fov =
      2 * Math.atan(w / this.camera.aspect / (2 * this.cameraDistance)) * (180 / Math.PI)
    // this.customPass.uniforms.uResolution.value.y = h / w
    this.camera.updateProjectionMatrix()
  }
}
